import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgBlockIcon = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 40,
	height: 32,
	viewBox: "0 0 40 32",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("rect", {
			width: 40,
			height: 32,
			rx: 4,
			fill: "#76ec71"
		}),
		/* @__PURE__ */ _jsx("g", {
			clipPath: "url(#clip0_828_13857)",
			children: /* @__PURE__ */ _jsx("path", {
				d: "M20 6.25C18.0716 6.25 16.1866 6.82183 14.5832 7.89317C12.9798 8.96451 11.7301 10.4873 10.9922 12.2688C10.2542 14.0504 10.0611 16.0108 10.4373 17.9021C10.8136 19.7934 11.7422 21.5307 13.1057 22.8943C14.4693 24.2579 16.2066 25.1865 18.0979 25.5627C19.9892 25.9389 21.9496 25.7458 23.7312 25.0078C25.5127 24.2699 27.0355 23.0202 28.1068 21.4168C29.1782 19.8134 29.75 17.9284 29.75 16C29.745 13.4157 28.7162 10.9386 26.8888 9.11118C25.0614 7.28378 22.5843 6.25496 20 6.25ZM23.75 16.75H20.75V19.75C20.75 19.9489 20.671 20.1397 20.5303 20.2803C20.3897 20.421 20.1989 20.5 20 20.5C19.8011 20.5 19.6103 20.421 19.4697 20.2803C19.329 20.1397 19.25 19.9489 19.25 19.75V16.75H16.25C16.0511 16.75 15.8603 16.671 15.7197 16.5303C15.579 16.3897 15.5 16.1989 15.5 16C15.5 15.8011 15.579 15.6103 15.7197 15.4697C15.8603 15.329 16.0511 15.25 16.25 15.25H19.25V12.25C19.25 12.0511 19.329 11.8603 19.4697 11.7197C19.6103 11.579 19.8011 11.5 20 11.5C20.1989 11.5 20.3897 11.579 20.5303 11.7197C20.671 11.8603 20.75 12.0511 20.75 12.25V15.25H23.75C23.9489 15.25 24.1397 15.329 24.2803 15.4697C24.421 15.6103 24.5 15.8011 24.5 16C24.5 16.1989 24.421 16.3897 24.2803 16.5303C24.1397 16.671 23.9489 16.75 23.75 16.75Z",
				fill: "#0f172b"
			})
		}),
		/* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
			id: "clip0_828_13857",
			children: /* @__PURE__ */ _jsx("rect", {
				width: 24,
				height: 24,
				fill: "white",
				transform: "translate(8 4)"
			})
		}) })
	]
});
export default SvgBlockIcon;
